<template>
  <div class="padding text-center" :class="{'white': $store.state.slide.textColour == '#ffffff'}">
    <div v-if="$store.state.slide.title || $store.state.slide.subheading">
      <h2
        class="title slide-title-style mt-0"
        :inner-html.prop="$store.state.slide.title | sanitize(true)"
      />
      <p class="subheading" :inner-html.prop="$store.state.slide.titleDesc | sanitize(true)" />
    </div>

    <!-- no content -->
    <div class="no-data" v-if="!$store.state.slide.title && !$store.state.slide.titleDesc">
      <h2 class="title slide-title-style mt-0">
        Ask me anything!
      </h2>
    </div>

    <div
      class="audio-control-slide"
      v-if="$store.state.slide.audioLink
        && $store.state.slide.audioPlayOnAudience && $store.state.slide.id"
    >
      <AudioControl />
    </div>

    <div class="img-slide" v-if="$store.state.slide.image">
      <img :src="$store.state.slide.image.large" alt="">
    </div>

    <Reaction />
  </div>
</template>
<script>
import Reaction from '@/components/Reaction.vue'
import AudioControl from '@/components/AudioControl.vue'

export default {
  components: {
    Reaction,
    AudioControl,
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
.img-slide {
  margin-bottom: 16px;
  img {
    max-width: 100%;
  }
}

.title {
  margin-bottom: 0;
}
.img-caption {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.icobutton--haha.active {
  span {
    color: $reaction-smiley-color !important;
  }
}
.icobutton--heart.active {
  span {
    color: rgb(243, 81, 134) !important;
  }
}
.icobutton--question.active {
  span {
    color: rgb(111, 151, 247) !important;
  }
}
.icobutton--like.active {
  span {
    color: $reaction-thumbs-up-color !important;
  }
}
.icobutton--dislike.active {
  span {
    color: rgb(255, 103, 103) !important;
  }
}
.text-center {
  text-align: center;
}

.padding {
  padding: 0 16px;
}

.title {
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 16px;
}

.subheading {
  margin: 0;
  font-size: 18px;
  height: 100%;
  white-space: pre-line;
  line-height: 25px;
  opacity: 0.7;
  margin-bottom: 16px;
}

.popup-enter-active {
  transition: all 0.4s ease;
}
.popup-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  transform: scale(1.5);
}
.popup-enter, .popup-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scale(0.5);
  opacity: 0;
}
.bullet-list {
  text-align: left;

  li {
    margin-bottom: 8px;
  }
}
</style>
